import { useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button'

export const ProteinPredLink = (uniprot) => {
  const navigationUrl = '/protein-struct-prediction/'
  const navigate = useNavigate()

  const redirect = () => {
    localStorage.setItem('proteinPredSmile', uniprot.value)
    navigate(navigationUrl)
  }

  return (
    <Button variant='contained' onClick={redirect}>{uniprot.value}</Button>
  )
}
